<div class="horizontal-select">
	<p class="select-label">{{ 'priority' | translate }}</p>
	<au-priority-level
		[showPriorityText]="true"
		[level]="formControl.value"
		[matMenuTriggerFor]="prioritySelect"
		(click)="$event.stopPropagation()"
	></au-priority-level>
</div>

<mat-menu #prioritySelect="matMenu" class="au-priority-select" yPosition="below">
	<div class="priorities-container">
		@for (item of priorityList; track item) {
			<div
				class="priority-wrapper"
				(click)="$event.stopPropagation(); setPriority(item.level)"
			>
				<div class="priority-text">{{ item.text | translate }}</div>
				<div class="priority-value">
					<au-priority-level class="d-flex" [level]="item.level"></au-priority-level>
				</div>
			</div>
		}
	</div>
</mat-menu>
